var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"promts_index\"\u003E\u003Cpromts-table :promts=\"promts\" :meta=\"meta\" @load-data=\"loadPromts\"\u003E\u003C\u002Fpromts-table\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;